import { useEffect, useState } from "react";
import ButtonLoading from "../general/ButtonLoading";
import moment from "moment";
import { POST_RESEND_SMS_OTP_URL } from "../../env";
import {
    postRecords,
    catchAsync,
    isSuccess,
} from "../../helper/helper";
function SendSMS({
    loading,
    username
}) {
    console.log("🚀 ~ SendSMS ~ username:", username)
    const [successMessage, setSuccessMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const postSmsOtp = catchAsync(async (req, res) => {
        const updateValues = {
            email: username, 
        };
        const response = await postRecords(POST_RESEND_SMS_OTP_URL, updateValues);
        if (response?.status === isSuccess) {
            setSuccessMessage(response?.message)
            setStatusMessage(response?.status)
        } else {
            setSuccessMessage(response?.message)
            setStatusMessage(response?.status)
        }
    });

    return (
        <div className="form-group">
            {
                successMessage !== "" && (
                    <div
                        className={`text-center alert ${statusMessage === "Success" ? "alert-success" : statusMessage === "Fail" && "alert-danger"
                            }`}
                    >
                        {successMessage}
                    </div>
                )
            }

            <button className="button btn btn-secondary" onClick={postSmsOtp}>
                {loading && <ButtonLoading />} Send OTP to Mobile
            </button>
        </div>
    );
}

export default SendSMS;
